// Lazer Lamps brand palette — dark chrome with a gold/yellow accent,
// matching LazerManagementAPP's theme (replacing the previous blue theme).
//
// BRAND_YELLOW is used for the dark chrome (header/sidebar/footer) and for
// AntD's colorPrimary (buttons, links) via the ConfigProvider in
// CannyWebApp.tsx.

export const BRAND_DARK = "#141414";
export const BRAND_YELLOW = "#F0B90B";
